// Langues réellement fournies par le MACTe (cf. iles.generated.js).
// Mapping fichiers : VFr -> fr | VAn -> en | VCr -> gcf | VEs -> es
// Allemand (de) et Italien (it) non fournis : ajouter ici s'ils arrivent.
export const LANGS = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'gcf', label: 'Kréyòl' },
  { code: 'es', label: 'Español' },
];

export const labelOfLang = (code) =>
  LANGS.find((l) => l.code === code)?.label || code;
